import * as uuid from 'uuid';
import type { default as DB } from '../db/DB';

export type LoginToken = { userId: string; expiresInMs: number };

export type CreateWebPlayerToken = (opts: { userId: string }) => string;

export class ServerReplicantLoginTokens {
    constructor(
        private opts: {
            db: DB<any>;
            dateNow: () => number;
            createWebPlayerToken: (opts: { userId: string }) => string;
        },
    ) {}

    async createLoginToken({ expiresInMs, userId }: LoginToken): Promise<string> {
        const token = uuid.v4();

        await this.opts.db.loginTokens.writeLoginToken({
            expiresAtMs: this.opts.dateNow() + expiresInMs,
            token,
            userId,
        });

        return token;
    }

    createWebPlayerToken(opts: { userId: string }): string {
        return this.opts.createWebPlayerToken(opts);
    }

    /** @returns `true` if a matching and non-expired login token was successfully consumed. */
    async consumeLoginToken({ token, userId }: { token: string; userId: string }): Promise<boolean> {
        const loginToken = await this.opts.db.loginTokens.fetchLoginToken({ token, userId });

        if (!loginToken) {
            return false;
        }

        const isExpired = loginToken.expiresAtMs <= this.opts.dateNow();
        if (isExpired) {
            return false;
        }

        await this.opts.db.loginTokens.deleteLoginToken({ token, userId });

        return true;
    }
}
